export default ['api', 'availabilityApiService', function (api, availabilityApiService) {
    return {
        find: (date, eventType, eventId, time, numberOfGuests = '') => {
            if (numberOfGuests) {
                numberOfGuests = `&guests=${numberOfGuests}`;
            }
            return api.get(`${availabilityApiService.switchEventType(eventType)}/${eventId}/quantity?date=${date}&time=${time}${numberOfGuests}`).
                then(response => response.data);
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/availability/services/quantity.api.service.js